import { render, staticRenderFns } from "./every-student.vue?vue&type=template&id=68f4af7f&"
import script from "./every-student.vue?vue&type=script&lang=js&"
export * from "./every-student.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports